import { Link } from "react-router-dom";

/** Always-visible party contact facts on SO/PO/SI/PI — plan/49. */
export function DocPartyStrip(props: {
  companySlug: string;
  partyId: string;
  partyName: string;
  roleLabel: "Customer" | "Supplier";
  primaryPhone?: string | null;
  primaryEmail?: string | null;
  primaryAddress?: string | null;
  partyNotes?: string | null;
  docNotes?: string | null;
}) {
  const phone = props.primaryPhone?.trim() || null;
  const email = props.primaryEmail?.trim() || null;
  const address = props.primaryAddress?.trim() || null;
  const partyNotes = props.partyNotes?.trim() || null;
  const docNotes = props.docNotes?.trim() || null;

  return (
    <div className="mt-3 space-y-1 text-sm">
      <div>
        <span className="text-[var(--color-muted)]">{props.roleLabel} · </span>
        <Link
          to={`/c/${props.companySlug}/contacts/${props.partyId}`}
          className="no-underline"
        >
          {props.partyName}
        </Link>
      </div>
      {phone ? (
        <div>
          <a href={`tel:${phone}`} className="font-mono text-xs no-underline">
            {phone}
          </a>
        </div>
      ) : null}
      {email ? (
        <div>
          <a href={`mailto:${email}`} className="text-xs no-underline">
            {email}
          </a>
        </div>
      ) : null}
      {address ? (
        <div className="text-xs text-[var(--color-muted)]">{address}</div>
      ) : null}
      {docNotes ? (
        <p className="m-0 pt-1 text-xs text-[var(--color-muted)]">
          <span className="font-medium text-[var(--color-foreground)]">
            Note ·{" "}
          </span>
          {docNotes}
        </p>
      ) : null}
      {partyNotes ? (
        <p className="m-0 text-xs text-[var(--color-muted)]">
          <span className="font-medium text-[var(--color-foreground)]">
            Contact ·{" "}
          </span>
          {partyNotes}
        </p>
      ) : null}
    </div>
  );
}
